import React from "react";
import { RouteObject, useRoutes } from "react-router-dom";

const Router = (props: { routes:any }) => {
  const routerTab = useRoutes(props.routes as RouteObject[]);
  return <div>{routerTab}</div>;
};

export default Router;
